import swalState from "utility/swal";
import { message } from "antd";
import GroupAPI from "services/group";
import { removeEmptyValues } from "utility/helperFunctions";

const PAGE_SIZE = 10;

function handleError(err) {
  console.error("Error in users actions: ", err);
}

export function setGroupList(payload) {
  return {
    type: "SET_GROUP_LIST",
    payload,
  };
}

export function updateGroupFilter(payload) {
  return {
    type: "UPDATE_GROUP_FILTER",
    payload,
  };
}

export function setGroupFilter(payload) {
  return {
    type: "SET_GROUP_FILTER",
    payload,
  };
}

async function fetchAndSetGroupList(dispatch, filters, { showLoader = true } = {}) {
  const requestFilters = { ...filters, pageSize: PAGE_SIZE };
  if (showLoader) {
    swalState.showLoader();
  }

  let response = await GroupAPI.getGroupList(removeEmptyValues(requestFilters));

  if (response) {
    const pageSize = response.pageSize || PAGE_SIZE;
    const currentPage = requestFilters.page ?? 0;
    const data = response.data || [];

    if (data.length === 0 && response.totalCount > 0 && currentPage > 0) {
      const lastPage = Math.max(0, Math.ceil(response.totalCount / pageSize) - 1);
      response = await GroupAPI.getGroupList(
        removeEmptyValues({ ...requestFilters, page: lastPage })
      );
      dispatch(updateGroupFilter({ page: lastPage }));
    }

    if (response) {
      const { data: listData, count, totalCount, prev, next, pageSize: responsePageSize } = response;
      dispatch(setGroupList({
        data: listData,
        pagination: {
          count,
          totalCount,
          prev,
          next,
          pageSize: responsePageSize,
        },
      }));
    }
  }

  return response;
}

export const getGroupList = (filters) => async (dispatch) => {
  try {
    await fetchAndSetGroupList(dispatch, filters);
  } catch (err) {
    message.error(err.message);
    handleError(err);
  } finally {
    swalState.hideLoader();
  }
};

export const updateGroupDetails = (id, updates) => async (dispatch, getState) => {
  try {
    swalState.showLoader();
    const response = await GroupAPI.updateGroupDetails(id, updates);
    if (response) {
      message.success("Group details updated successfully");
      const filters = { ...getState().Group.filters, pageSize: PAGE_SIZE };
      await fetchAndSetGroupList(dispatch, filters, { showLoader: false });
    }
  } catch (err) {
    message.error(err.message);
    handleError(err);
  } finally {
    swalState.hideLoader();
  }
};

export const updateFilters = (update) => async (dispatch) => {
  try {
    swalState.hideLoader();
    dispatch(updateGroupFilter(update));
  } catch (err) {
    handleError(err);
  }
};

export const setFilters = (update) => async (dispatch) => {
  try {
    swalState.hideLoader();
    dispatch(setGroupFilter(update));
  } catch (err) {
    handleError(err);
  }
};
